import {h} from 'preact';
import {appendHashToUrl} from '@util/URLUtils';

const Item = ( {title, url, urlHash} ) =>
    <a href={appendHashToUrl( url, urlHash )}
       className="nav-item-sub txt-c1 hover:text-inherit pl-4 py-1 block hover:underline">
        {title}
    </a>;

export default Item;